module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.cd6e6d1.woff2";